const LOGIN_MESSAGES = {
  LOGINPAGE_TITLE: "login",
  LOGINPAGE_SUBTITLE: "with",
  GOOGLE_TEXT: "GOOGLE",
  FB_TEXT: "FACEBOOK",
  LOGINPAGE_PH_USERID: "Email / Phone Number",
  LOGINPAGE_PH_PASSWORD: "Password",
  FORGOT_PASS_TEXT: "forgot password?",
  LOGIN_BTN_TEXT: "LOGIN",
  NEW_USER_TEXT: "New user?",
  REGISTER_TEXT: "Register",
  REGISTERPAGE_TITLE: "register",
  REGISTERPAGE_SUBTITLE: "to your new account",
  REGISTERPAGE_PH_NAME: "Name",
  REGISTERPAGE_PH_MOBILENO: "Mobile Number",
  REGISTERPAGE_PH_EMAIL: "Email Address",
  REGISTERPAGE_PH_PASSWORD: "Password",
  FORGOTPASSPAGE_TITLE: "forgot",
  FORGOTPASSPAGE_SUBTITLE: "your password?",
  FORGOTPASSPAGE_PH_USERID: "Email / Phone Number",
  FORGOTPASSWORD_INVALID_CREDENTIALS: "Please enter valid Email / Phone Number",
  CREATEACCOUNT: "Create Account",
  BACKTOLOGIN: "Back to login",
  SUCCESSFULL_SIGNUP_MESSAGE:
    "Welcome, you're one of us NNNOW. Thanks for signing up.",
  FAILED_RESET_PASSWORD_MESSAGE:
    "Failed to reset password. Please try again later.",
  RESET_PASSWORD_SUCCESSFUL: "Your password is reset successfully.",
  MESSAGE_SENT: "sent, Please Check",
  DEFAULT_VALID_DATA_MESSAGE: "Please enter valid Data",
  UNABLE_TO_CONNECT_TO_FB:
    "Sorry! not able to connect to Facebook. Please try login via Email or Google",
  FAILED_TO_LOGIN_WITH_GMAIL:
    "Failed to Login with Gmail. Check your Gmail Credentials.",
  FB_CREDENTIAL_ERROR:
    "Not able to get your email or phone number from facebook",
  INVALID_DATA: "Please enter valid Data",
  INVALID_CREDENTIALS: "Please enter valid credentials",
  INVALID_ID: "Please enter valid email/phone number",
};

export { LOGIN_MESSAGES };



// WEBPACK FOOTER //
// ./src/constants/login.js